
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jura",
      function () {
        return require("private-next-pages/jura/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jura"])
      });
    }
  